import { render, staticRenderFns } from "./ModalInfoHeader.vue?vue&type=template&id=6410a3f4&"
import script from "./ModalInfoHeader.vue?vue&type=script&lang=ts&"
export * from "./ModalInfoHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports